/**
 * Copyright 2025 MadeByTatwa LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Colored logging utilities for OmniRun CLI
 */
import pc from 'picocolors';

export const logger = {
  /**
   * Log success message in green
   */
  success: (message: string) => {
    console.log(pc.green(`✅ ${message}`));
  },

  /**
   * Log error message in red
   */
  error: (message: string) => {
    console.error(pc.red(`❌ ${message}`));
  },

  /**
   * Log warning message in yellow
   */
  warn: (message: string) => {
    console.warn(pc.yellow(`⚠️  ${message}`));
  },

  /**
   * Log info message in cyan
   */
  info: (message: string) => {
    console.log(pc.cyan(`ℹ️  ${message}`));
  },

  /**
   * Log plain message without color
   */
  log: (message: string) => {
    console.log(message);
  },

  /**
   * Log debug message in gray (only in verbose mode)
   */
  debug: (message: string, verbose = false) => {
    if (verbose) {
      console.log(pc.gray(`🔍 ${message}`));
    }
  },

  /**
   * Log a header with styling
   */
  header: (message: string) => {
    console.log(pc.bold(pc.cyan(`\n${message}`)));
  },

  /**
   * Log a list item
   */
  listItem: (message: string, indent = 2) => {
    console.log(`${' '.repeat(indent)}• ${message}`);
  },
};

